import ProductDetail from '@/components/productDetail';
import { useEffect, useState } from 'react';
import { noLoginProduct } from '@/services/rpc/customize';
import { handleSKUList } from '@/services/newProduct';
import './index.scss';
import { Toast } from 'antd-mobile';
import { v4 as uuid } from 'uuid';
import fabric from '@/pages/customize/utils/fabric';
import { base64ToFile } from '@/pages/customize/utils';
import {
  addCart,
  createCheckout,
  getUploadToken,
  uploadCustomizeInfo
} from '@/services/rpc/customize';
import OSS from 'ali-oss';
import { useTranslation } from 'react-i18next';
import { getMainEnvHost, jumpToUrl } from '@/services/url';
import ga4Api from '@/packages/jsapi/logger/ga4';

let hasSubmit = false;
const canvasConfig = {
  yResolution: 100,
  customWidth: window.innerWidth,
  customHeight: window.innerWidth * 1.2 * 0.8
};
const ProductBuy = (props: any) => {
  const { t } = useTranslation();
  const { itemId, visible, setVisible, cover, canvasIns, type = 1 } = props;
  const [num, setNum] = useState<number>(1);
  const [selectedVariant, setSelectedVariant] = useState<any>(null);
  const [productOptions, setProductOptions] = useState<any>(null);
  const [data, setData] = useState<any>(null);

  const initClient = async () => {
    const result: any = await getUploadToken();
    const client = new OSS({
      region: result.region,
      accessKeyId: result.accessKeyId,
      accessKeySecret: result.accessKeySecret,
      stsToken: result.securityToken,
      bucket: result.bucketName
    });
    return client;
  };

  const getImage = async (): Promise<any> => {
    const w = window.innerWidth;
    return new Promise<any>(async (resolve, reject) => {
      Toast.show({ icon: 'loading', content: 'waiting', duration: 0 });
      const copy = new fabric.Canvas('copy');
      copy.setHeight(w);
      copy.setWidth(w * 1.2);
      const imageList: any = [];
      const client = await initClient();

      const currentCanvas = canvasIns;
      const currentMetaData = {
        customLeft: 0.1 * canvasConfig.customHeight,
        customTop: 0.1 * canvasConfig.customHeight,
        customWidth: canvasConfig.customWidth,
        customHeight: canvasConfig.customHeight
      };
      const dataUrl = currentCanvas.toDataURL({
        format: 'png',
        quality: 1,
        multiplier: 4
      }); 
      const json = currentCanvas.toJSON();
      copy.loadFromJSON(json, async () => {
        copy.renderAll();
        const dataUrl1 = copy.toDataURL({
          format: 'png',
          quality: 1,
          multiplier: 4,
          left: currentMetaData.customLeft,
          top: currentMetaData.customTop,
          width: currentMetaData.customWidth,
          height: currentMetaData.customHeight
        });

        const file1 = await base64ToFile(dataUrl);
        const file2 = await base64ToFile(dataUrl1);
        const mainId = uuid();
        const mainImage = await client.put(`${mainId}.png`, file1);
        const customizedImage = await client.put(`${uuid()}.png`, file2);
        imageList.push({
          text: '',
          type: 'customize_user_base_front',
          mainImage: `https://order-refund.hhocool.com/${mainImage.name}`,
          customizedImage: `https://order-refund.hhocool.com/${customizedImage.name}`
        });
        copy.clear();
        // if (window.location.host.indexOf('localhost') > -1) {
        //   const link = document.createElement('a');
        //   link.download = 'currentCanvas.png';
        //   link.href = dataUrl1;
        //   document.body.appendChild(link);
        //   link.click();
        //   document.body.removeChild(link);
        // }

        const templateId: string = await uploadCustomizeInfo({
          itemId,
          materialList: imageList
        });
        Toast.clear();
        resolve({
          // @ts-ignore
          mainId,
          templateId,
          imageUrl: imageList[0].mainImage
        });
      });
    });
  };

  const addToCart = async () => {
    if (hasSubmit) return;
    hasSubmit = true;
    try {
      const { imageUrl, templateId } = await getImage();
      const params = {
        skuId: selectedVariant.skuId,
        quantity: num,
        itemId: itemId,
        purchaseType: 'ECO',
        templateId,
        customizeOriginalImage: imageUrl
      };
      const result = await addCart(params);
      Toast.show({
        content: t('add_cart_success')
      });
    } catch (err) {
      hasSubmit = false;
      Toast.show({
        content: '数量が上限を超えました'
      });
    }
  };
  const checkoutOrder = async () => {
    if (hasSubmit) return;
    hasSubmit = true;
    try {
      const { imageUrl, templateId } = await getImage();
      const params = {
        lineItemList: [
          {
            itemId: itemId,
            skuId: selectedVariant.skuId,
            quantity: num,
            customizeOriginalImage: imageUrl,
            templateId
          }
        ],
        source: 'customize' as 'customize',
        cartId: -1
      };

      const result = await createCheckout(params);
      const url = `${window.location.protocol}//${getMainEnvHost()}${result.hhoWebUrl
        .split('?')
        .join('.html?')}`;
      ga4Api({
        eventName: 'begin_checkout',
        params: {
          checkout_id: result.checkoutId,
          channel: 'koutu_edit',
          currency: 'JPY',
          isCustomized: 1,
          order_type: 'btn_eco_buy',
          value: selectedVariant.price,
          item_id: itemId
        }
      });
      jumpToUrl(url);
    } catch (err) {
      hasSubmit = false;
    }
  };

  useEffect(() => {
    noLoginProduct({ itemId }).then((res: any) => {
      // TODO 先默认颜色
      let data = res.data.item;
      setData(data);
      let optionList = data?.itemSkuOptions.filter((item) => {
        return item.type !== 'color';
      });
      const productOptions = handleSKUList(data?.skuList || [], optionList || []);
      setProductOptions(productOptions);
      setSelectedVariant(data?.skuList[0]);
    });
  }, []);
  return (
    <ProductDetail
      data={{
        type,
        cover,
        addToCart: type === 1 ? checkoutOrder : addToCart,
        visible,
        setVisible,
        selectedVariant,
        setSelectedVariant,
        productOptions,
        current: data,
        num,
        setNum
      }}
    />
  );
};

export default ProductBuy;
